var Account, Breadcrumbs, DateView, GridView, HeadingBar, HomePage, NoAccount, Page, m;

m = require('mithril');

Account = require('../../state/Account');

Page = require('../components/Page');

NoAccount = require('../components/NoAccount');

HeadingBar = require('../components/HeadingBar');

Breadcrumbs = require('../components/Breadcrumbs');

GridView = require('../components/GridView');

DateView = require('../components/DateView');

HomePage = {
  view: function(ctrl, args) {
    var account, galleries, ref;
    account = args.account();
    if (account == null) {
      return m(NoAccount);
    }
    galleries = (ref = args.galleries()) != null ? ref : [];
    return m(Page, {
      account: account,
      content: [
        m(HeadingBar, {
          content: m(Breadcrumbs, {
            items: [
              {
                icon: 'home',
                content: 'Galleries'
              }
            ]
          })
        }), galleries.length > 0 ? [
          m('p', 'Select from your available galleries:'), m('ul', galleries.map(function(gallery) {
            return m('li', [
              m('a', {
                href: "/gallery/" + gallery.id + "/thumbs",
                config: m.route
              }, gallery.name)
            ]);
          }))
        ] : m('p', 'Sorry, there are no galleries available.')
      ]
    });
  }
};

module.exports = function(store) {
  return m(HomePage, {
    account: function() {
      return store.getState().account;
    },
    galleries: function() {
      return store.getState().galleries;
    }
  });
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvcGFnZXMvSG9tZVBhZ2UuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL2FwcC9zcmMvdWkvcGFnZXMvSG9tZVBhZ2UuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsQ0FBQSxHQUFJLE9BQUEsQ0FBUSxTQUFSOztBQUVKLE9BQUEsR0FBVyxPQUFBLENBQVEscUJBQVI7O0FBQ1gsSUFBQSxHQUFTLE9BQUEsQ0FBUSxvQkFBUjs7QUFDVCxTQUFBLEdBQVksT0FBQSxDQUFRLHlCQUFSOztBQUNaLFVBQUEsR0FBYSxPQUFBLENBQVEsMEJBQVI7O0FBQ2IsV0FBQSxHQUFjLE9BQUEsQ0FBUSwyQkFBUjs7QUFDZCxRQUFBLEdBQVksT0FBQSxDQUFRLHdCQUFSOztBQUNaLFFBQUEsR0FBVyxPQUFBLENBQVEsd0JBQVI7O0FBRVgsUUFBQSxHQUFXO0VBQ1YsSUFBQSxFQUFNLFNBQUMsSUFBRCxFQUFPLElBQVA7QUFDTCxRQUFBO0lBQUEsT0FBQSxHQUFVLElBQUksQ0FBQyxPQUFMLENBQUE7SUFDVixJQUEwQixlQUExQjtBQUFBLGFBQU8sQ0FBQSxDQUFFLFNBQUYsRUFBUDs7SUFFQSxTQUFBLDRDQUErQjtXQUUvQixDQUFBLENBQUUsSUFBRixFQUFRO01BQ1AsT0FBQSxFQUFTLE9BREY7TUFFUCxPQUFBLEVBQVM7UUFDUixDQUFBLENBQUUsVUFBRixFQUFjO1VBQ2IsT0FBQSxFQUFTLENBQUEsQ0FBRSxXQUFGLEVBQWU7WUFBQyxLQUFBLEVBQU87Y0FDL0I7Z0JBQ0MsSUFBQSxFQUFNLE1BRFA7Z0JBRUMsT0FBQSxFQUFTLFdBRlY7ZUFEK0I7YUFBUjtXQUFmLENBREk7U0FBZCxDQURRLEVBU0wsU0FBUyxDQUFDLE1BQVYsR0FBbUIsQ0FBdEIsR0FDQztVQUNDLENBQUEsQ0FBRSxHQUFGLEVBQU8sdUNBQVAsQ0FERCxFQUVDLENBQUEsQ0FBRSxJQUFGLEVBQVEsU0FBUyxDQUFDLEdBQVYsQ0FBYyxTQUFDLE9BQUQ7bUJBQ3JCLENBQUEsQ0FBRSxJQUFGLEVBQVE7Y0FDUCxDQUFBLENBQUUsR0FBRixFQUFPO2dCQUNOLElBQUEsRUFBTSxXQUFBLEdBQVksT0FBTyxDQUFDLEVBQXBCLEdBQXVCLFNBRHZCO2dCQUVOLE1BQUEsRUFBUSxDQUFDLENBQUMsS0FGSjtlQUFQLEVBR0csT0FBTyxDQUFDLElBSFgsQ0FETzthQUFSO1VBRHFCLENBQWQsQ0FBUixDQUZEO1NBREQsR0FZQyxDQUFBLENBQUUsR0FBRixFQUFPLDBDQUFQLENBckJPO09BRkY7S0FBUjtFQU5LLENBREk7OztBQW1DWCxNQUFNLENBQUMsT0FBUCxHQUFpQixTQUFDLEtBQUQ7U0FDaEIsQ0FBQSxDQUFFLFFBQUYsRUFBWTtJQUNYLE9BQUEsRUFBUyxTQUFBO2FBQU0sS0FBSyxDQUFDLFFBQU4sQ0FBQSxDQUFnQixDQUFDO0lBQXZCLENBREU7SUFFWCxTQUFBLEVBQVcsU0FBQTthQUFNLEtBQUssQ0FBQyxRQUFOLENBQUEsQ0FBZ0IsQ0FBQztJQUF2QixDQUZBO0dBQVo7QUFEZ0IifQ==
